import {useCallback, useEffect, useEffectEvent, useState} from 'react';
import type {BulkUpdateSummary, DataLoadStatus, HttpError} from 'api';
import {getBulkUpdates} from 'api/bulkUpdate';
import {useGetTokens} from 'services/auth';

export const useBulkUpdates = (page: number, pageSize: number) => {
  const getTokens = useGetTokens();

  const [result, setResult] = useState<DataLoadStatus<BulkUpdateSummary[]>>({
    status: 'NotLoaded',
  });
  const onSetResult = useEffectEvent(setResult);
  const [rowCount, setRowCount] = useState<number>(0);

  const get = useCallback(
    (page: number, size: number) => {
      return getBulkUpdates(getTokens, page, size);
    },
    [getTokens],
  );

  useEffect(() => {
    onSetResult(old => ({status: 'Loading', data: old.data}));
    get(page, pageSize)
      .then(data => {
        onSetResult(() => ({status: 'Loaded', data: data.items}));
        setRowCount(data.elements);
      })
      .catch((error: HttpError) => {
        onSetResult(() => ({status: 'Failed', error}));
      });
  }, [get, page, pageSize]);

  return {
    ...result,
    rowCount,
  };
};
